import { render, staticRenderFns } from "./_gameRules_cn.vue?vue&type=template&id=5ddeb639&lang=pug&"
import script from "./_gameRules_cn.vue?vue&type=script&lang=js&"
export * from "./_gameRules_cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports